import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";

const COPY = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "B&H Truck Dispatching respects your privacy. Information you submit through this website — including carrier registration details, contact form entries, and uploaded onboarding documents such as W-9 forms, certificates of insurance, and operating authority documents — is used solely to evaluate your inquiry and to communicate with you about our dispatching services.",
      "Uploaded documents are stored privately and are accessible only to authorized B&H Truck Dispatching administrators. We do not sell, rent, or share your personal information or business documents with third parties for marketing purposes.",
      "By submitting a form on this website, you consent to being contacted by B&H Truck Dispatching by phone, text, or email regarding your inquiry. You may request that we update or remove your information at any time by contacting us directly.",
      "This website may use standard analytics to understand how visitors use the site. No personally identifiable information is sold or disclosed through analytics.",
    ],
  },
  terms: {
    title: "Terms of Service",
    body: [
      "The content on this website is provided for general informational purposes about B&H Truck Dispatching and the dispatching support services we offer to carriers.",
      "Submitting a carrier registration or contact form does not create a dispatching relationship. Any dispatching services are governed by a separate dispatch service agreement reviewed and signed during onboarding.",
      "B&H Truck Dispatching does not guarantee freight availability, specific rates, or business outcomes. All load acceptance decisions remain with the carrier.",
      "By using this website you agree not to misuse the forms, upload malicious files, or attempt to access restricted areas of the site without authorization.",
    ],
  },
};

export default function Legal({ type = "privacy" }) {
  const page = COPY[type] || COPY.privacy;
  return (
    <main data-testid={`${type}-page`} className="pt-32 pb-24 px-4 sm:px-8 lg:px-16 max-w-3xl mx-auto">
      <Seo title={`${page.title} | B&H Truck Dispatching`} description={`${page.title} for the B&H Truck Dispatching website.`} />
      <Reveal>
        <p className="overline-label mb-4">Legal</p>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-white mb-10">{page.title}</h1>
        <div className="space-y-6">
          {page.body.map((p, i) => (
            <p key={i} className="text-sm sm:text-base text-zinc-400 leading-relaxed">{p}</p>
          ))}
        </div>
      </Reveal>
    </main>
  );
}
